import { Amplify } from 'aws-amplify';

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_USER_POOL_ID as string,
      userPoolClientId: import.meta.env.VITE_USER_POOL_Client_ID as string,
      identityPoolId: import.meta.env.VITE_IDENTITY_POOL_ID as string,
      loginWith: {
        email: true,
        phone: true,
      },
      signUpVerificationMethod: 'link',
      userAttributes: {
        email: {
          required: true,
        },
        phone_number: {
          required: true,
        },
        given_name: {
          required: true,
        },
        family_name: {
          required: true,
        },
      },
      passwordFormat: {
        minLength: 8,
        requireLowercase: true,
        requireUppercase: true,
        requireNumbers: true,
        requireSpecialCharacters: true,
      },
    },
  },
});
